(function(global){
"use strict";

var Ctor=global.QRCode;
if(typeof Ctor!=="function"){
  console.error("Kampansera QR: QRCode.js encoder missing.");
  return;
}
global.KampanseraQRCodeJS=Ctor;

function colorOpt(opts,key,fallback){
  return opts&&opts.color&&opts.color[key]?opts.color[key]:(opts&&opts[key==="dark"?"fg":"bg"]?opts[key==="dark"?"fg":"bg"]:fallback);
}
function levelFrom(opts){
  var wanted=String(opts&&opts.errorCorrectionLevel||"M").toUpperCase();
  var levels=Ctor.CorrectLevel||{};
  return levels[wanted]!==undefined?levels[wanted]:(levels.M!==undefined?levels.M:0);
}
function encode(text,opts){
  var holder=document.createElement("div");
  var instance=new Ctor(holder,{
    text:String(text||""),
    width:256,
    height:256,
    colorDark:"#000000",
    colorLight:"#ffffff",
    correctLevel:levelFrom(opts||{})
  });
  var model=instance._oQRCode;
  if(!model||typeof model.getModuleCount!=="function"||typeof model.isDark!=="function"){
    throw new Error("QR-matris kunde inte skapas.");
  }
  var count=model.getModuleCount();
  var rows=new Array(count);
  for(var y=0;y<count;y++){
    rows[y]=new Array(count);
    for(var x=0;x<count;x++)rows[y][x]=!!model.isDark(y,x);
  }
  return {matrix:rows,count:count};
}
function decodeCanvas(canvas){
  if(typeof global.jsQR!=="function")return null;
  try{
    var ctx=canvas.getContext("2d",{willReadFrequently:true});
    var image=ctx.getImageData(0,0,canvas.width,canvas.height);
    var result=global.jsQR(image.data,image.width,image.height,{inversionAttempts:"attemptBoth"});
    return result&&result.data?result.data:null;
  }catch(e){return null;}
}
function render(canvas,text,opts){
  opts=opts||{};
  var encoded=encode(text,opts);
  var margin=opts.margin===undefined?4:Math.max(4,Number(opts.margin)||4);
  var total=encoded.count+margin*2;
  var requested=Number(opts.width)||0;
  var modulePx=Number(opts.scale)||0;
  if(!modulePx){
    if(requested)modulePx=Math.max(4,Math.round(requested/total));
    else modulePx=6;
  }
  modulePx=Math.max(4,Math.round(modulePx));
  var dim=total*modulePx;
  canvas.width=dim;
  canvas.height=dim;
  canvas.style.width=dim+"px";
  canvas.style.height=dim+"px";
  canvas.style.maxWidth="100%";
  canvas.style.imageRendering="pixelated";

  var ctx=canvas.getContext("2d",{alpha:false});
  ctx.imageSmoothingEnabled=false;
  ctx.fillStyle=colorOpt(opts,"light","#FFFFFF");
  ctx.fillRect(0,0,dim,dim);
  ctx.fillStyle=colorOpt(opts,"dark","#14162B");
  for(var y=0;y<encoded.count;y++){
    for(var x=0;x<encoded.count;x++){
      if(encoded.matrix[y][x]){
        ctx.fillRect((x+margin)*modulePx,(y+margin)*modulePx,modulePx,modulePx);
      }
    }
  }

  var decoded=decodeCanvas(canvas);
  var verified=decoded===String(text||"");
  canvas.dataset.qrVerified=verified?"true":"false";
  canvas.dataset.qrModules=String(encoded.count);
  canvas.setAttribute("aria-label","QR-kod till "+String(text||""));
  if(!verified&&typeof global.jsQR==="function"){
    // Retry at a larger integer module size before giving up.
    modulePx=Math.max(7,modulePx+2);
    dim=total*modulePx;
    canvas.width=dim;canvas.height=dim;
    canvas.style.width=dim+"px";canvas.style.height=dim+"px";
    ctx=canvas.getContext("2d",{alpha:false});
    ctx.imageSmoothingEnabled=false;
    ctx.fillStyle=colorOpt(opts,"light","#FFFFFF");ctx.fillRect(0,0,dim,dim);
    ctx.fillStyle=colorOpt(opts,"dark","#14162B");
    for(var yy=0;yy<encoded.count;yy++)for(var xx=0;xx<encoded.count;xx++){
      if(encoded.matrix[yy][xx])ctx.fillRect((xx+margin)*modulePx,(yy+margin)*modulePx,modulePx,modulePx);
    }
    decoded=decodeCanvas(canvas);
    verified=decoded===String(text||"");
    canvas.dataset.qrVerified=verified?"true":"false";
  }
  return canvas;
}
function normalizeCanvasArgs(canvas,text,opts,cb){
  if(typeof opts==="function"){cb=opts;opts={};}
  return {canvas:canvas,text:text,opts:opts||{},cb:cb};
}
function toCanvas(canvas,text,opts,cb){
  var a=normalizeCanvasArgs(canvas,text,opts,cb);
  try{
    render(a.canvas,a.text,a.opts);
    if(typeof a.cb==="function")a.cb(null,a.canvas);
    return Promise.resolve(a.canvas);
  }catch(e){
    if(typeof a.cb==="function")a.cb(e);
    return Promise.reject(e);
  }
}
function toDataURL(text,opts,cb){
  if(typeof opts==="function"){cb=opts;opts={};}
  try{
    var canvas=document.createElement("canvas");
    render(canvas,text,opts||{});
    var url=canvas.toDataURL("image/png");
    if(typeof cb==="function")cb(null,url);
    return Promise.resolve(url);
  }catch(e){
    if(typeof cb==="function")cb(e);
    return Promise.reject(e);
  }
}
function drawToCanvas(canvas,text,opts){
  return render(canvas,text,opts||{});
}
var api={
  toCanvas:toCanvas,
  toDataURL:toDataURL,
  drawToCanvas:drawToCanvas,
  generate:encode,
  selfTest:function(canvas,text){return decodeCanvas(canvas)===String(text||"");},
  decodeCanvas:decodeCanvas,
  CorrectLevel:Ctor.CorrectLevel||{}
};
global.KampanseraReliableQR=api;
global.KampanseraLegacyQR=api;
global.QRCode=api;
})(window);